import React from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';
import MultistepFormsNav from '../../../headers/FormHeaders/MultistepFormsNav.jsx';
import MultiSelect from '../../../MultiSelect.jsx';
import EmployeesFormField from '../../../employees-form-field/EmployeesFormField.jsx';
import AuthorizedAction from '../../../AuthorizedAction.js';

const additionalFields = {
  email: '',
  employees: [],
};

function StepGovernanceManuallyForm({
  entities,
  handleSubmit,
  formRef,
  loading,
  employeeSearchParams,
  onShowEmployeeModal,
  onSelectOwner,
  onSelectEmployee,
  projectOwners,
  onCancel,
  onBack,
  values,
  errorsEmpl,
}) {
  const { owners, committee, sponsors, resources } = entities;

  return (
    <form onSubmit={handleSubmit} ref={formRef}>
      <MultistepFormsNav
        activeIndex={2}
        onBack={onBack}
        onSubmit={handleSubmit}
        type="changeStrategy"
      />
      <Row>
        <Col xs={10}>
          <ControlLabel>Select Owner(s)</ControlLabel>

          <MultiSelect
            options={projectOwners}
            selectedOptions={owners}
            updateSelectedOptions={onSelectOwner}
            placeholder="Select People"
            subject="Owner"
            nameKey="name"
            deleteMsg="Are you sure you want to detach this change strategy owner?"
            additionalFields={additionalFields}
            error={errorsEmpl.owners || ''}
          />
        </Col>
        <Col xs={10} className="m-b-24">
          <EmployeesFormField
            selected={committee}
            handleSelect={(e) => onSelectEmployee('committee', e)}
            additionalSearchParams={employeeSearchParams}
            title="Select Steering Committee"
            isItemActive={(eId) => committee.some(({ id }) => id === eId)}
            addBtn={
              <AuthorizedAction action="create" subject="employee">
                <button
                  type="button"
                  className="btn-link"
                  onClick={() => onShowEmployeeModal('committee')}
                >
                  {' '}
                  + Add People
                </button>
              </AuthorizedAction>
            }
          />
        </Col>

        <Col xs={10} className="m-b-24">
          <EmployeesFormField
            selected={sponsors}
            handleSelect={(e) => onSelectEmployee('sponsors', e)}
            additionalSearchParams={employeeSearchParams}
            title={`Select ${getOrgTermsContent('projectSponsors')}`}
            isItemActive={(eId) => sponsors.some(({ id }) => id === eId)}
            addBtn={
              <AuthorizedAction action="create" subject="employee">
                <button
                  type="button"
                  className="btn-link"
                  onClick={() => onShowEmployeeModal('sponsors')}
                >
                  {' '}
                  + Add People
                </button>
              </AuthorizedAction>
            }
          />
        </Col>
        <Col xs={10} className="m-b-24">
          <EmployeesFormField
            selected={resources}
            handleSelect={(e) => onSelectEmployee('resources', e)}
            additionalSearchParams={employeeSearchParams}
            title="Select Supporting Resource(s)"
            isItemActive={(eId) => resources.some(({ id }) => id === eId)}
            addBtn={
              <AuthorizedAction action="create" subject="employee">
                <button
                  type="button"
                  className="btn-link"
                  onClick={() => onShowEmployeeModal('resources')}
                >
                  {' '}
                  + Add People
                </button>
              </AuthorizedAction>
            }
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepGovernanceManuallyForm;
